import Vue from 'vue'
import Vuex from 'vuex'
// import app from './modules/app'

Vue.use(Vuex)

const requireStore = require.context('./modules/', false, /[a-z]\w+\.(js)$/)
const modules = requireStore.keys().reduce((p, n) => {
  const name = n.replace(/\.\//, '').replace(/\.js/, '')
  const store = {}
  store[name] = requireStore(n).default
  return { ...p, ...store }
}, {})

export default new Vuex.Store({
  modules
})
